/** Grymwyrd em português brasileiro para o recurso Play / VTT. */
export const playPtBR = {
  // CampaignList
  'play.campaigns.heading': 'Minhas Campanhas',
  'play.campaigns.signIn': 'Faça login',
  'play.campaigns.signInToSee': 'para ver as campanhas em que você entrou.',
  'play.campaigns.fallbackNotice': 'Exibindo campanhas de exemplo — seu elenco não pôde ser carregado.',
  'play.campaigns.loading': 'Recordando suas sagas…',
  'play.campaigns.empty': 'Você ainda não entrou em nenhuma campanha.',
  'play.campaigns.assignedCharacter': 'Personagem Atribuído',
  'play.campaigns.unassigned': 'Não atribuído',
  'play.campaigns.noCharactersYet': 'Nenhum personagem ainda',
  'play.campaigns.enterCampaign': 'Entrar na campanha',

  // CampaignPage — VTT prototype
  'play.vtt.theTable': 'A Mesa',
  'play.vtt.launch': 'Iniciar VTT',
  'play.vtt.iframeTitle': 'Grymwyrd VTT — campanha {campaignId}',
  'play.vtt.veilHeadline': 'O véu entre mesa e conto é fino por aqui.',
  'play.vtt.prototypeIntro':
    'A mesa de jogo virtual em tempo real é uma fase posterior. O protótipo interativo será incorporado neste quadro — pressione',
  'play.vtt.prototypeOutro': 'para preparar o container.',

  // CampaignPage — encyclopedia sidebar
  'play.codex.heading': 'Busca Rápida no Códice',
  'play.codex.searchPlaceholder': 'Procure um monstro, feitiço, regra…',
  'play.codex.searchAriaLabel': 'Buscar na enciclopédia',
  'play.codex.searching': 'Adivinhando…',
  'play.codex.noResults': 'Nada encontrado para "{q}".',
  'play.codex.hint': 'Digite pelo menos duas letras para buscar a enciclopédia viva sem sair de sua mesa.',

  // CampaignPage — detail
  'play.campaign.fallbackTitle': 'Campanha',
  'play.campaign.fallbackDescription':
    'Os detalhes da campanha não puderam ser carregados — você ainda pode preparar seu personagem abaixo.',
  'play.campaign.seoTitle': 'Campanha',
  'play.campaign.noneSpecified': 'Nenhuma campanha especificada.',
  'play.campaign.seoTitleNamed': '{title} — Play',
  'play.campaign.seoTitleDefault': 'Campanha — Play',
  'play.campaign.backToLobby': 'Voltar ao saguão',
  'play.campaign.gm': 'Mestre {gm}',
  'play.campaign.playersCount': '{count} jogadores',

  // CharacterSheet
  'play.sheet.savedToCodex': 'Salvo no seu códice.',
  'play.sheet.savedLocally': 'Salvo localmente (servidor indisponível).',
  'play.sheet.saveError': 'Não foi possível salvar seu personagem — o armazenamento está indisponível.',
  'play.sheet.loading': 'Desenrolando a ficha…',
  'play.sheet.heading': 'Ficha de Personagem',
  'play.sheet.avatarAlt': 'Avatar de {name}',
  'play.sheet.unclaimedHero': 'Herói sem dono',
  'play.sheet.abilityCheck': 'Teste de {ability} ({formula}):',
  'play.sheet.name': 'Nome',
  'play.sheet.namePlaceholder': 'Viajante sem nome',
  'play.sheet.level': 'Nível',
  'play.sheet.speciesLabel': 'Ancestralidade / Espécie',
  'play.sheet.loadingOption': 'Carregando…',
  'play.sheet.selectSpecies': 'Selecione a espécie',
  'play.sheet.classLabel': 'Classe',
  'play.sheet.selectClass': 'Selecione a classe',
  'play.sheet.abilityScores': 'Atributos',
  'play.sheet.abilityScoresHint': '(clique no modificador para rolar)',
  'play.sheet.abilityScoreAria': 'Atributo de {ability}',
  'play.sheet.rollCheckAria': 'Rolar um teste de {ability}',
  'play.sheet.hp': 'PV',
  'play.sheet.maxHp': 'PV Máximo',
  'play.sheet.ac': 'CA',
  'play.sheet.backstory': 'História de Fundo',
  'play.sheet.backstoryPlaceholder': 'Que escuridão trouxe esta alma para a mesa?',
  'play.sheet.canonCandidate': 'Candidato ao Cânone',
  'play.sheet.canonCandidateHint': 'Inclua este personagem na consideração para fazer parte do cânone vivo de Grymwyrd.',
  'play.sheet.saving': 'Salvando…',
  'play.sheet.saveCharacter': 'Salvar Personagem',

  // CreateGameModal
  'play.create.errorNoName': 'Dê um nome à sua mesa.',
  'play.create.errorNoSystem': 'Escolha um sistema de jogo.',
  'play.create.you': 'Você',
  'play.create.errorCreate': 'O ritual falhou — sua mesa não pôde ser criada. Tente novamente em breve.',
  'play.create.modalTitle': 'Convocar uma Mesa',
  'play.create.successCopy': 'Sua mesa está montada. Compartilhe este link de convite para chamar seus jogadores.',
  'play.create.copyInviteAria': 'Copiar link de convite',
  'play.create.copied': 'Copiado',
  'play.create.copy': 'Copiar',
  'play.create.done': 'Pronto',
  'play.create.tableName': 'Nome da Mesa',
  'play.create.tableNamePlaceholder': 'ex. A Câmara do Luto',
  'play.create.quickStart': 'Início Rápido',
  'play.create.quickStartAria': 'Presets de início rápido',
  'play.create.customPreset': 'Personalizado',
  'play.create.customPresetDesc': 'Começar do zero',
  'play.create.gameSystem': 'Sistema de Jogo',
  'play.create.loadingSystems': 'Carregando sistemas…',
  'play.create.systemFromPreset': '{system} (do preset)',
  'play.create.systemDefault': 'Grymwyrd Cataclysm (padrão)',
  'play.create.tags': 'Tags',
  'play.create.tagsUpTo': '(até {count})',
  'play.create.removeTagAria': 'Remover tag {tag}',
  'play.create.tagLimitReached': 'Limite de tags atingido',
  'play.create.tagPlaceholder': 'horror, one-shot…',
  'play.create.maxPlayers': 'Máximo de Jogadores:',
  'play.create.cancel': 'Cancelar',
  'play.create.convening': 'Convocando…',
  'play.create.createTable': 'Criar Mesa',

  // JoinPage
  'play.join.finding': 'Procurando a mesa…',
  'play.join.expiredHeading': 'Este convite expirou',
  'play.join.expiredBody': 'Os códigos expiram por segurança. Peça ao seu anfitrião um novo.',
  'play.join.browseLiveTables': 'Procurar mesas ao vivo',
  'play.join.errorHeading': 'Não foi possível acessar a mesa',
  'play.join.errorBody': 'Algo deu errado ao procurar seu convite. Verifique sua conexão e tente novamente.',
  'play.join.tryAgain': 'Tentar novamente',
  'play.join.defaultTableTitle': 'Uma mesa de Grymwyrd',
  'play.join.invited': 'Você foi convidado para sentar-se.',
  'play.join.signInToSeat': 'Faça login para tomar seu lugar',
  'play.join.createAccount': 'Novo aqui? Crie uma conta gratuita',
  'play.join.opensAfterSignIn': 'A mesa se abre após você fazer login.',

  // PlayLobbyPage
  'play.lobby.seoTitle': 'Play — Mesa de Jogo Virtual',
  'play.lobby.seoDescription':
    'Encontre uma mesa, entre em uma sessão ao vivo e forge sua lenda na mesa de jogo virtual de Grymwyrd.',
  'play.lobby.eyebrow': 'Mesa de Jogo Virtual',
  'play.lobby.title': 'Play',
  'play.lobby.subtitle':
    'Reúna seu aquelarre. Role os ossos. Sente-se em uma mesa onde cada escolha ecoa através do cânone vivo de Grymwyrd.',
  'play.lobby.createGame': 'Criar Jogo',
  'play.lobby.playNow': 'Jogar Agora — sem conta necessária',
  'play.lobby.signInToHost': 'Faça login para sediar sua própria mesa',

  // SessionListLive
  'play.live.heading': 'Ao Vivo Agora',
  'play.live.empty': 'Nenhuma mesa está ao vivo nesta hora. O véu está quieto — inicie a sua.',
  'play.live.badge': 'Ao Vivo',
  'play.live.unknownSystem': 'Sistema desconhecido',
  'play.live.gmSuffix': ' · Mestre {gm}',
  'play.live.players': 'jogadores',

  // TableList — empty board
  'play.tables.emptyHeading': 'Nenhuma mesa aberta ainda',
  'play.tables.emptyBody':
    'O tabuleiro está silencioso por agora. Seja o primeiro a puxar uma cadeira — tente a mesa de convidado instantaneamente, sem conta necessária.',
  'play.tables.tryGuestTable': 'Tente a mesa de convidado',
  'play.tables.orUse': 'Ou use',
  'play.tables.createGame': 'Criar Jogo',
  'play.tables.aboveToHost': 'acima para sediar sua própria.',

  // TableList — waitlist
  'play.waitlist.joinError': 'Não foi possível entrar na fila de espera — tente novamente.',
  'play.waitlist.leaveError': 'Não foi possível sair da fila de espera — tente novamente.',
  'play.waitlist.join': 'Entrar na fila de espera',
  'play.waitlist.leaving': 'Saindo…',
  'play.waitlist.leave': 'Sair da fila de espera',
  'play.waitlist.joining': 'Entrando…',

  // TableList — board
  'play.tables.heading': 'Mesas Abertas',
  'play.tables.openSeatOnly': 'Apenas assento aberto',
  'play.tables.systemFilterPlaceholder': 'Sistema…',
  'play.tables.systemFilterAria': 'Filtrar por sistema',
  'play.tables.tagsFilterPlaceholder': 'Tags (separadas por vírgula)…',
  'play.tables.tagsFilterAria': 'Filtrar por tags',
  'play.tables.fetchError': 'Não foi possível acessar o tabuleiro ao vivo — o saguão está temporariamente indisponível.',
  'play.tables.loading': 'Reunindo mesas…',
  'play.tables.untitledTable': 'Mesa sem título',
  'play.tables.full': 'Completa',
  'play.tables.seatedCount': '{count} sentados',
  'play.tables.viewTable': 'Ver Mesa',

  // ── Live chat (P-E) — per-recipient translation (Option A) ────────────────
  'chat.heading': 'Chat da Mesa',
  'chat.empty': 'Nenhuma mensagem ainda. Diga algo para a mesa.',
  'chat.inputPlaceholder': 'Mensagem para a mesa…',
  'chat.inputAria': 'Mensagem de chat',
  'chat.send': 'Enviar',
  'chat.translatedFrom': 'Traduzido de {lang}',
  'chat.original': 'Original',
  'chat.showOriginal': 'Mostrar original',
  'chat.showTranslation': 'Mostrar tradução',
  'chat.showOriginalsAll': 'Mostrar originais',
  'chat.showTranslationsAll': 'Mostrar traduções',
};
